// ----------------------------------------------------------------------------
// Snippet: Free Shipping Progress
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';
import {formatMoney} from '@shopify/theme-currency';

function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ',',
    decimal = '.'
) {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
);
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
}


Shopify.freeShippingProgress = (function($){

    var _config = {
        progressContainerSelector : '.free-shipping-progress__container',
        minimumSubtotalAttribute  : 'data-minimum-subtotal',
        shopifyAjaxCartURL        : window.localeUrl+'/cart.js',
        freeShippingMessage       : window.translations.freeShippingMessage,
        moneyFormat               : theme.moneyFormat, // Based on the shop money format
    };

    var _init = function(){

        var _freeShippingProgressHtml = function(cart, minimumSubtotal){

            var html = '';

            if (theme.moneyFormat == '${{ amount_no_decimals}}') {
                var $cartSubtotal = parseInt(formatWithDelimiters(cart.items_subtotal_price, 0)*100);
            } else {
                var $cartSubtotal = parseInt(cart.items_subtotal_price);
            };

            html += '<span class="free-shipping-progress__message">';
                if( $cartSubtotal >= minimumSubtotal){// Free Shipping
                    html += _config.freeShippingMessage;
                }else{
                    var $priceDifference = formatMoney(minimumSubtotal - $cartSubtotal, _config.moneyFormat);
                    if (window.localeUrl == '/fr') {
                        html += 'À ' + $priceDifference + ' ' + window.translations.notFreeShippingMessage;
                    } else {
                        html += $priceDifference + ' ' + window.translations.notFreeShippingMessage;
                    }
                }
            html += '</span>';

            return html;
        }

        $(document).ready(function(){

            var $progressContainers = $(_config.progressContainerSelector);

            if( $progressContainers.length ){
                var $minimumSubtotal = false;

                $.each($progressContainers, function(){

                    if( $(this).attr(_config.minimumSubtotalAttribute) != 'false'){
                        $minimumSubtotal = parseInt($progressContainers.attr(_config.minimumSubtotalAttribute));
                        return false;
                    }
                })

                if( $minimumSubtotal != false){
                    $.ajax({
                        url: _config.shopifyAjaxCartURL,
                        cache: false,
                        dataType: "json",
                        success: function(cart) {
                            var freeShippingProgressHtml = _freeShippingProgressHtml(cart, $minimumSubtotal);
                            $.each($progressContainers, function(){
                                $(this).html(freeShippingProgressHtml);
                            })
                        }
                    });
                }
            }
        })
    }
    return {
        init: function(params) {
                // Configuration
                params = params || {};
                // Merging with defaults.
                $.extend(_config, params);
                // Action
                $(function() {
                    _init();
                });
        },
        getConfig: function() {
            return _config;
        }
    }
})($)

Shopify.freeShippingProgress.init();
